// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Drag-and-drop uploader. Root: .drag-upload */
.drag-upload .drag-upload__zone .ant-upload-drag {
  background: var(--ds-bg);
  border-color: var(--ds-border);
}

.drag-upload .drag-upload__zone .ant-upload-drag:hover {
  border-color: var(--ds-brand);
}

.drag-upload .drag-upload__zone .ant-upload-btn {
  padding: var(--ds-space-4) var(--ds-space-5);
}

.drag-upload__prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-3);
  min-height: 44px;
  text-align: center;
  font-weight: 600;
  color: var(--ds-text);
}

.drag-upload__icon {
  font-size: 20px;
  color: var(--ds-brand-strong);
}

.drag-upload__cta {
  color: var(--ds-brand-strong);
}

.drag-upload__hint {
  font-weight: 400;
  color: var(--ds-text-2);
}

.drag-upload__files {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-3);
  margin-top: var(--ds-space-3);
}

.drag-upload__thumb {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  overflow: visible;
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface);
}

.drag-upload__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--ds-radius-md);
}

/* Remove button sits on the corner; the pseudo-element extends its hit area to 40px. */
.drag-upload .drag-upload__remove {
  position: absolute;
  top: -8px;
  inset-inline-end: -8px;
  box-shadow: var(--ds-shadow-sm);
}

.drag-upload .drag-upload__remove::after {
  content: "";
  position: absolute;
  inset: -8px;
}
`, "",{"version":3,"sources":["webpack://./src/commons/DragUpload/Dragger.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,uFAAuF;AACvF;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["/* Drag-and-drop uploader. Root: .drag-upload */\n.drag-upload .drag-upload__zone .ant-upload-drag {\n  background: var(--ds-bg);\n  border-color: var(--ds-border);\n}\n\n.drag-upload .drag-upload__zone .ant-upload-drag:hover {\n  border-color: var(--ds-brand);\n}\n\n.drag-upload .drag-upload__zone .ant-upload-btn {\n  padding: var(--ds-space-4) var(--ds-space-5);\n}\n\n.drag-upload__prompt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--ds-space-3);\n  min-height: 44px;\n  text-align: center;\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.drag-upload__icon {\n  font-size: 20px;\n  color: var(--ds-brand-strong);\n}\n\n.drag-upload__cta {\n  color: var(--ds-brand-strong);\n}\n\n.drag-upload__hint {\n  font-weight: 400;\n  color: var(--ds-text-2);\n}\n\n.drag-upload__files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-3);\n  margin-top: var(--ds-space-3);\n}\n\n.drag-upload__thumb {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  overflow: visible;\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface);\n}\n\n.drag-upload__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--ds-radius-md);\n}\n\n/* Remove button sits on the corner; the pseudo-element extends its hit area to 40px. */\n.drag-upload .drag-upload__remove {\n  position: absolute;\n  top: -8px;\n  inset-inline-end: -8px;\n  box-shadow: var(--ds-shadow-sm);\n}\n\n.drag-upload .drag-upload__remove::after {\n  content: \"\";\n  position: absolute;\n  inset: -8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
